import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Grid, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import CancelIcon from "@material-ui/icons/Cancel";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CommentIcon from '@material-ui/icons/Comment';
import { BorderGreenButton } from "../../utils/form/buttonsForm";
import { withStyles } from "@material-ui/core/styles";
import RequisitionVacant from "../../pages/requisitions/requisitionVacant";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';


const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const DetailedAccordion = (props) => {
  const {
    headers,
    data,
    onEdit,
    onDelete,
    onApprove,
    onPublish,
    onClose,
    onReject,
    permissionsRequisition,
    permissionsConstans,
    dataContract,
    statusListContractType,
    onShowObservation
  } = props;

  const classes = useStyles();
  const id = IdKey.generate();
  const [showForm, setShowForm] = useState(false);
  const [showObservationOption, setShowObservationOption] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "contractType" && statusListContractType === "success" && dataContract) {
          let clave = object[header.field]?.toUpperCase();
          let valor = dataContract.find(
            (contrato) => contrato.contractTypes === clave
          );
          return valor ? valor.contractTypeDescription : "";
        }
        if (header.field === "status") {
          return object[header.field]
            ?.replaceAll("_", " ")
            .replace("cion", "ción");
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };
  const onShowForm = () => {
    setShowForm(true);
  };
  const handleClose = () => {
    setShowForm(false);
  };

  const onPublishVacant = (vacant) => {
    onPublish(vacant);
    setShowForm(false);
  };

  useEffect(() => {
    if(typeof onShowObservation === 'function') {
      setShowObservationOption(true);
    } else {
      setShowObservationOption(false);
    }
  }, []);

  const showDeleteButton = (id) => {
    const showButton = data.status === "EN_ELABORACION" && permissionsRequisition?.functionalities?.some(
      (x) => x === permissionsConstans.REQ_ANULAR
    );
    return (
      showButton &&
      <Tooltip title="Anular" arrow placement="top">
        <DeleteIcon
          onClick={() => onDelete(id)}
          className={classes.iconEvent}
          style={{ fontSize: 40, pointerEvents: "auto" }}
        />
      </Tooltip>
    )
  }

  const showDetailsButton = () => {
    return !showDetails && (
      <Tooltip title="Ver detalle" arrow placement="top">
        <VisibilityIcon
          onClick={() => setShowDetails(true)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent} />
      </Tooltip>
    )
  }
  const hideDetailsButton = () => {
    return showDetails && (
      <Tooltip title="Ocultar detalle" arrow placement="top">
        <VisibilityOffIcon
          onClick={() => setShowDetails(false)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent} />
      </Tooltip>
    )
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
        expanded={showDetails}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            &nbsp;&nbsp;
            {showDetailsButton()}
            &nbsp;&nbsp;
            {hideDetailsButton()}
            &nbsp;&nbsp;
            {data.status === "EN_ELABORACION" &&
              permissionsRequisition?.functionalities?.some(
                (x) => x === permissionsConstans.REQ_EDITAR
              ) && (
                <Tooltip title="Editar" arrow placement="top">
                  <EditIcon
                    onClick={() => onEdit(data.id)}
                    className={classes.iconEvent}
                    style={{ fontSize: 40, pointerEvents: "auto" }}
                  />
                </Tooltip>
              )}
            &nbsp;&nbsp;
            {showDeleteButton(data.id)}
            &nbsp;&nbsp;
            {data.status === "PENDIENTE_POR_APROBACION" &&
              permissionsRequisition?.functionalities?.some(
                (x) => x === permissionsConstans.REQ_MANAGE_APROBAR
              ) && (
                <Tooltip title="Aprobar" arrow placement="top">
                  <ThumbUpIcon
                    onClick={() => onApprove(data.id)}
                    className={classes.iconEvent}
                    style={{ fontSize: 40, pointerEvents: "auto" }}
                  />
                </Tooltip>
              )}
            &nbsp;&nbsp;
            {(data.status.toUpperCase() === "PENDIENTE_POR_APROBACION" ||
              data.status.toUpperCase() === "APROBADO") &&
              permissionsRequisition?.functionalities?.some(
                (x) => x === permissionsConstans.REQ_MANAGE_CERRAR
              ) && (
                <Tooltip title="Rechazar" arrow placement="top">
                  <ThumbDownIcon
                    onClick={() => onReject(data.id)}
                    className={classes.iconEvent}
                    style={{ fontSize: 40, pointerEvents: "auto" }}
                  />
                </Tooltip>
              )}
            &nbsp;&nbsp;
            {(data.status.toUpperCase() === "PENDIENTE_POR_APROBACION" ||
              data.status.toUpperCase() === "RECHAZADO" ||
              data.status.toUpperCase() === "APROBADO" ||
              data.status.toUpperCase() === "PUBLICADO") &&
              permissionsRequisition?.functionalities?.some(
                (x) => x === permissionsConstans.REQ_MANAGE_CERRAR
              ) && (
                <Tooltip title="Cerrar" arrow placement="top">
                  <CancelIcon
                    onClick={() => onClose(data?.id)}
                    className={classes.iconEvent}
                    style={{ fontSize: 40, pointerEvents: "auto" }}
                  />
                </Tooltip>
              )}
              &nbsp;&nbsp;
              {showObservationOption &&
                <Tooltip title="Ver Observaciones" arrow placement="top">
                  <CommentIcon
                    onClick={() => onShowObservation(data?.id)}
                    className={classes.iconEvent}
                    style={{ fontSize: 40, pointerEvents: "auto" }}
                  />
                </Tooltip>
              }
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={3}>
              {headers.otherHeaders.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {getValueByKey(data, header)}
                  </Typography>
                </Grid>
              ))}

              {data.status.toUpperCase() === "APROBADO" &&
                permissionsRequisition?.functionalities?.some(
                  (x) => x === permissionsConstans.REQ_MANAGE_PUBLICAR
                ) && (
                  <Grid item xs={2}>
                    <BorderGreenButton onClick={onShowForm}>
                      Publicar Vacante
                    </BorderGreenButton>
                  </Grid>
                )}

              <RequisitionVacant
                requisitionId={data.id}
                showForm={showForm}
                onPublish={(vacant) => onPublishVacant(vacant)}
                handleClose={handleClose}
              />
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default React.memo(DetailedAccordion);
